"use client";

import { useMemo } from "react";
import { useAppSelector } from "@/store";
import { isSystems247Brand } from "@/lib/branding";
import {
  getFallbackUiLanguageOptions,
  getUiLanguageOptionByLocale,
  getUiLanguageShortLabel,
  normalizeUiLanguageOptions,
  SYSTEMS247_UI_LANGUAGES,
  type UiLanguageOption,
} from "@/shared/i18n/languages";

const SYSTEMS247_UI_LANGUAGE_OPTIONS = normalizeUiLanguageOptions(SYSTEMS247_UI_LANGUAGES);

export function useUiLanguageOptions(): UiLanguageOption[] {
  const options = useAppSelector((state) => state.uiLanguages.options);

  return useMemo(() => {
    if (isSystems247Brand()) {
      return SYSTEMS247_UI_LANGUAGE_OPTIONS;
    }

    if (Array.isArray(options) && options.length > 0) {
      return options;
    }

    return getFallbackUiLanguageOptions();
  }, [options]);
}

export function useUiLanguageShortLabel(locale: string | null | undefined): string {
  const options = useUiLanguageOptions();

  return useMemo(() => {
    return getUiLanguageOptionByLocale(options, locale)?.short
      ?? getUiLanguageShortLabel(locale ?? "");
  }, [locale, options]);
}
